import React, { MouseEventHandler } from 'react'

import { Div } from 'elements/layout/Div'
import { Text } from 'elements/text/Text'
import { Help } from 'elements/ui/Help'

export type TIntentionSectionTitleProps = {
  onRightButtonClick?: MouseEventHandler
}

export const IntentionSectionTitle: TFCC<TIntentionSectionTitleProps> = ({ children, onRightButtonClick }) => (
  <Div align="middleBetween">
    <Text upper bold fontSize="1em" p="10px 5px 5px" color="black30">
      {children}
    </Text>
    {onRightButtonClick && <Help onClick={onRightButtonClick} />}
  </Div>
)
